import posthog from 'posthog-js';
import { config } from './config.js';

/** @import {PostHogConfig} from 'posthog-js' */

/**
 * Initializes the PostHog analytics library for tracking user interactions.
 */
export function initPostHog(appName) {
  /** @type {Partial<PostHogConfig>} */
  const postHogConfig = {
    api_host: 'https://bees.katapultpro.com',
    defaults: '2026-01-30',
    opt_out_capturing_by_default: true
  };

  if (appName !== 'katapult-production') {
    // Disable all automatic capture features except for pageviews and pageleaves
    postHogConfig.autocapture = false;
    postHogConfig.capture_dead_clicks = false;
    postHogConfig.rageclick = false;
    postHogConfig.capture_performance = {
      web_vitals_allowed_metrics: []
    };
    // Filter out all events except for pageview, pageleave, identify, and set (for user properties)
    postHogConfig.before_send = (event) => {
      if (!event) return null;

      const allowedEventTypes = ['$pageview', '$pageleave', '$identify', '$set'];
      if (!allowedEventTypes.includes(event.event)) {
        return null; // Block all events except the allowed types
      }
      return event;
    };
  }

  // Initialize PostHog
  posthog.init(config.postHogApiKey, postHogConfig);

  console.log('PostHog initialized');
}
